var _path, _rect, _path2, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProperties(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 21H22",
    stroke: "#403B37",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 13,
    width: 4,
    height: 8,
    stroke: "#403B37",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 17H6.5",
    stroke: "#403B37",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 2,
    width: 12,
    height: 19,
    rx: 1,
    stroke: "#403B37",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 5,
    width: 2,
    height: 2,
    fill: "#403B37"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 5,
    width: 2,
    height: 2,
    fill: "#403B37"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 8.5,
    width: 2,
    height: 2,
    fill: "#403B37"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 8.5,
    width: 2,
    height: 2,
    fill: "#403B37"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 12,
    width: 2,
    height: 2,
    fill: "#403B37"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 15.5,
    width: 2,
    height: 2,
    fill: "#403B37"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProperties);
export default __webpack_public_path__ + "static/media/properties.7f7e72942fbe8994345b244d56140279.svg";
export { ForwardRef as ReactComponent };